import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { InfoTooltip } from "@/lib/dashboard/InfoTooltip";
import { useI18n } from "@/hooks/useI18n";

interface OverviewCardHeaderProps {
  title: string;
  info: string;
  /** Rotta della sezione che approfondisce la card. Omessa dove non esiste un "dopo". */
  to?: string;
}

/**
 * Titolo di una card della Panoramica, con l'ingresso alla sua sezione.
 *
 * Il titolo e' nero e in grassetto perche' e' un titolo: prima era grigio e piccolo come
 * un'etichetta, e tre etichette in fila non dicevano dove finiva una card e cominciava
 * l'altra. Il link sta sulla stessa riga, a destra: la Panoramica risponde in sintesi, e
 * la risposta lunga e' sempre in un'altra pagina -- dirlo dove nasce la domanda evita il
 * giro dalla barra laterale.
 *
 * Senza `to` la riga resta il solo titolo: "Statistiche" non ha una pagina propria, e un
 * link che riporta alla Panoramica sarebbe peggio di nessun link.
 */
export function OverviewCardHeader({ title, info, to }: OverviewCardHeaderProps) {
  const { t } = useI18n();

  return (
    <div className="flex items-center justify-between gap-3">
      <h3 className="text-base font-semibold text-gray-900">
        {title}{" "}
        <InfoTooltip text={info} />
      </h3>

      {to && (
        <Link
          to={to}
          className="inline-flex items-center gap-1.5 text-sm text-gray-600 underline underline-offset-4 hover:text-gray-900 flex-shrink-0"
        >
          {t("dashboard.overview.goToSection")}
          <ArrowRight className="h-4 w-4" />
        </Link>
      )}
    </div>
  );
}

export default OverviewCardHeader;
